import find from 'lodash/fp/find';
import flow from 'lodash/fp/flow';
import get from 'lodash/fp/get';

const languages = [
	{
		locale: 'en',
		name: 'English',
		isoCode: 'en-US',
		ojCode: 'E',
		dateFnsLocale: 'enUS',
		recaptcha: 'en',
	},
	{
		locale: 'fr',
		name: 'French',
		isoCode: 'fr-FR',
		ojCode: 'F',
		dateFnsLocale: 'fr',
		recaptcha: 'fr',
	},
	{
		locale: 'de',
		name: 'German',
		isoCode: 'de-DE',
		ojCode: 'D',
		dateFnsLocale: 'de',
		recaptcha: 'de',
	},
	{
		locale: 'es',
		name: 'Spanish (Latin American)',
		isoCode: 'es-419',
		ojCode: 'S',
		dateFnsLocale: 'es',
		recaptcha: 'es-419',
	},
	{
		locale: 'es-es',
		name: 'Spanish (Castilian)',
		isoCode: 'es-ES',
		ojCode: 'S',
		dateFnsLocale: 'es',
		recaptcha: 'es',
	},
	{
		locale: 'zh',
		name: 'Chinese',
		isoCode: 'zh-CN',
		ojCode: 'CH',
		dateFnsLocale: 'zhCN',
		recaptcha: 'zh-CN',
	},
	{
		locale: 'ar',
		name: 'Arabic',
		isoCode: 'ar-SA',
		ojCode: 'AR',
		dateFnsLocale: 'ar',
		recaptcha: 'ar',
	},
	{
		locale: 'jp',
		name: 'Japanese',
		isoCode: 'ja-JP',
		ojCode: 'J',
		dateFnsLocale: 'ja',
		recaptcha: 'ja',
	},
	{
		locale: 'ru',
		name: 'Russian',
		isoCode: 'ru-RU',
		ojCode: 'R',
		dateFnsLocale: 'ru',
		recaptcha: 'ru',
	},
	{
		locale: 'zh_hant',
		name: 'Traditional Chinese',
		isoCode: 'zh-TW',
		ojCode: 'TW',
		dateFnsLocale: 'zhTW',
		recaptcha: 'zh-TW',
	},
	{
		locale: 'br',
		name: 'Brazillian Portuguese',
		isoCode: 'pt-BR',
		ojCode: 'BR',
		dateFnsLocale: 'ptBR',
		recaptcha: 'pt-BR',
	},
	{
		locale: 'pt',
		name: 'Portuguese',
		isoCode: 'pt-PT',
		ojCode: 'P',
		dateFnsLocale: 'pt',
		recaptcha: 'pt-PT',
	},
	{
		locale: 'it',
		name: 'Italian',
		isoCode: 'it-IT',
		ojCode: 'I',
		dateFnsLocale: 'it',
		recaptcha: 'it',
	},
	{
		locale: 'kr',
		name: 'Korean',
		isoCode: 'ko-KR',
		ojCode: 'KO',
		dateFnsLocale: 'ko',
		recaptcha: 'ko',
	},
	{
		locale: 'tr',
		name: 'Turkish',
		isoCode: 'tr-TR',
		ojCode: 'TR',
		dateFnsLocale: 'tr',
		recaptcha: 'tr',
	},
	{
		locale: 'gr',
		name: 'Greek',
		isoCode: 'el-GR',
		ojCode: 'GK',
		dateFnsLocale: 'el',
		recaptcha: 'el',
	},
];

export function getRecaptchaLocale(locale) {
	return languages.find(l => l.locale === locale)?.recaptcha;
}

export default languages;

export function getIsoCodeForLocale(locale) {
	return flow(find({ locale }), get('isoCode'))(languages);
}

export function getDateFnsLocale(lang) {
	return flow(
		find(({ locale, isoCode, dateFnsLocale }) => [locale, isoCode, dateFnsLocale].includes(lang)),
		get('dateFnsLocale')
	)(languages);
}

export function getPageLanguage() {
	return (
		get(['FS', 'propertyInfo', 'language'])(window) || get(['documentElement', 'lang'])(document)
	);
}
